import React from 'react';
import { Result, Button } from 'antd';
import { ReloadOutlined, HomeOutlined } from '@ant-design/icons';
import Sentry from '../utils/sentry';
import errorLogger, { summarizeError } from '../common/util/errorLogger';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
    if (process.env.NODE_ENV === 'production') {
      Sentry.captureException(error, { extra: { componentStack: errorInfo?.componentStack } });
    } else {
      errorLogger.error('SJ-APP-003', 'react error boundary caught render error', {
        ...summarizeError(error),
        componentStack: errorInfo && errorInfo.componentStack,
      });
    }
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    try {
      const CONFIG = require('../config').default;
      window.location.href = CONFIG.DEV_MODE ? '/' : 'https://shijian.live/portal.html';
    } catch (e) {
      window.location.href = '/';
    }
  };

  render() {
    if (this.state.hasError) {
      return (
        <Result
          status="error"
          title="页面出了点问题"
          subTitle="抱歉，页面发生了意外错误。您可以尝试刷新页面或返回首页。"
          extra={[
            <Button
              key="reload"
              type="primary"
              icon={<ReloadOutlined />}
              onClick={this.handleReload}
            >
              刷新页面
            </Button>,
            <Button key="home" icon={<HomeOutlined />} onClick={this.handleGoHome}>
              返回首页
            </Button>,
          ]}
          style={{ padding: '60px 20px' }}
        >
          {process.env.NODE_ENV === 'development' && this.state.error && (
            <div
              style={{
                marginTop: 24,
                padding: 16,
                background: 'var(--sj-bg-elevated)',
                borderRadius: 8,
                border: '1px solid var(--sj-border-light)',
                textAlign: 'left',
                overflow: 'auto',
                maxHeight: 400,
              }}
            >
              <pre style={{ margin: 0, color: 'var(--sj-text-secondary)', fontSize: 12 }}>
                {this.state.error.toString()}
                {'\n'}
                {this.state.errorInfo?.componentStack}
              </pre>
            </div>
          )}
        </Result>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
